<template>
	<div></div>
</template>
<script>
import { writehtml } from './WriteExecl.js'
export default {
	methods: {},
	mounted() {
		const data = JSON.parse(localStorage.getItem('execl'))
		writehtml(data)
	}
}
</script>
